import { Component } from '@angular/core';
import { ODataModel } from '../../../interfaces/odata-model.interface';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
    selector: 'pace-core-outmodel',
    templateUrl: './outmodel.component.html',
    styleUrls: ['./outmodel.component.scss'],
})
export class OutmodelComponent {
    public model: ODataModel;
    public label: string;
    public constructor(public readonly modalInstance: BsModalRef) {}
}
